import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import a1 from "../../../../assets/build/a1.png"
import "../buidl.css";

function Herosection() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleContextMenu = (e) => {
    e.preventDefault(); // Disable right-click
  };

  return (
    <div 
      fluid 
      className="container-section" 
      style={{
        backgroundColor: "#272A38",
        padding: 0,
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
       
        height: isSmallScreen ? 'auto' : '100vh' // Conditional height based on screen size
      }}
    >
      <Image src={a1} alt='a1' width="100%" draggable="false" onContextMenu={handleContextMenu}  height="auto" />
    </div>
  );
}

export default Herosection;